
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from 'react-router-dom';
import Management3 from "../Accountandhistory/Food/Management3";
import CashBillingdata from "../Accountandhistory/Food/CashBillingdata";
import MobileCashorders from "../Accountandhistory/Food/MobileCashorders";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import "./Foodandbeverags.css"
const FoodAccuont = () => {
    const isMobile = window.innerWidth <= 768;
    const location = useLocation();
    const [activeCategory, setActiveCategory] = useState("overview");

    useEffect(() => {
        if (location.state?.activeCategory === 'Payments') {
            setActiveCategory('Payments');
        }
    }, [location]);

    useEffect(() => {
        if (location.state?.activeCategory === 'Profile') {
            setActiveCategory('Profile');
        }
    }, [location]);

    useEffect(() => {
        if (location.state?.activeCategory === 'Notifications') {
            setActiveCategory('Notifications');
        }
    }, [location]);
    // Function to handle card click and set the active category
    const handleClick = (category) => {
        setActiveCategory(category);
    };

    const navigate = useNavigate();

    return (
        <>
            <div className="container-fluid">

                <div className="row" style={{ marginTop: "60px" }}>

                    {/* Left Column - Scrollable Category List */}
                    <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                        <div
                            style={{
                                maxHeight: "600px",
                                position: "sticky",
                                top: "0px",
                                marginTop: "5px",
                                zIndex: 1000,
                                width: "180px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",

                            }}
                        >


                            <div className="category-container" style={{
                                overflowY: "auto",
                                height: "540px",
                                marginTop: "68px",
                                scrollbarWidth: "thin",
                                msOverflowStyle: "none",
                            }}>
                                {/* Category Cards */}
                                {[].map(
                                    (category, index) => (
                                        <div
                                            key={index}
                                            className="category-card"
                                            onClick={() => handleClick(category)}
                                            style={{
                                                backgroundColor: activeCategory === category ? "rgb(177 93 198)" : "#D9D9D9",
                                                margin: "8px 0",
                                                padding: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                cursor: "pointer",
                                                justifyContent: "center",
                                                borderRadius: "15px",
                                                transition: "0.3s ease-in-out",
                                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                            }}
                                        >
                                            {/* Icon inside a fixed-size wrapper */}


                                            <div style={{ fontSize: "20px", fontWeight: "bold" }} className="category-card-body d-flex justify-content-center p-0">
                                                {category}
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                            {/* <MobileCashorders /> */}

                        </div>
                    </div>

                    {/* Right Column - Content Based on Active Category */}
                    <div className="col-lg-10 col-md-10 col-sm-12 col-12 cartdta-mobiley biling-account-data" style={{ paddingLeft: "0px", paddingRight: "0px" }}  >

                        <p
                            className="breadcrumb maamaas-home-bredcum"
                            style={{
                                position: "fixed",
                                top: window.innerWidth <= 425 ? "50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "60px" : "64px",
                                left: "2vw",
                                width: "100%",
                                backgroundColor: "#fff",
                                zIndex: 1000,
                                padding: "10px 0",
                                fontSize: isMobile ? "16px" : "18px",
                                fontWeight: isMobile ? "normal" : "bold",
                                textAlign: "center",
                                margin: 0,
                            }}
                        >
                            {/* <Link
                                to="/Newmainlandingpage"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Home
                            </Link> */}
                            {/* <span className="separator"> &gt; </span> */}
                            <Link
                                to="/fooddashboard"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Food & Beverages
                            </Link>
                            <span className="separator"> &gt; </span>
                            <Link
                                // to="/company"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Account History
                            </Link>


                        </p>


                        <div
                            style={{
                                marginTop: "55px",
                                // backgroundColor: "#f1f1f1",
                                borderRadius: "8px",
                            }}
                        >
                            {/* Show different details based on active category */}
                            {activeCategory === "overview" && (
                                <div>
                                    {/* <h3>Cart Details</h3> */}
                                    <Management3 />
                                </div>
                            )}

                        </div>
                    </div>
                </div>
                {/* <div className="col-lg-3" style={{display: window.innerWidth <= 768 ? "none" : "block",}}>
                    <CashBillingdata />

                </div> */}




            </div>
        </>
    );
};

export default FoodAccuont;
